CustomTC.define('modules/flag',['modules/util', 'modules/core', 'modules/constants', 'modules/options', 'modules/load-data', 'text!modules/htmls/flag.html', 'css!modules/css/flag'], function(util, core, constants, options, loadData, flagModal) {
    return {
    	initFlag: function(video, isAjaxAllowed) {
    		core.append(core.init('.' + constants.CSS_TOUCHCAST_MAIN_WRAPPER + ''), flagModal);
            var flagBtn = core.init('.' + constants.CSS_TOUCHCAST_FLAG_BUTTON + '');
    		var flag = util.readCookie('flag');
    		if (flag) {
    			flag = decodeURIComponent(flag);
    			flag = flag.split("-");
    			if (flag[0] === 1 && flag[1] === video.id)
    				core.hide(flagBtn);
    			else
    				core.show(flagBtn);
    		}
    		if (isAjaxAllowed === 1) {
                core.off(flagBtn, 'touchstart click');
                core.on(flagBtn, 'touchstart click', function(e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    core.addClass(core.init('.' + constants.CSS_TOUCHCAST_FLAG_MODAL + ''), constants.CSS_TOUCHCAST_OPEN);
                    return false;
                });

                var flagSubmitBtn = core.init('.' + constants.CSS_TOUCHCAST_FLAG_MODAL + ' .' + constants.CSS_TOUCHCAST_SUBMIT_FLAG_BUTTON + '');
                core.off(flagSubmitBtn, 'touchstart click');
                core.on(flagSubmitBtn, 'touchstart click', function(e) {
                    e.preventDefault();
                    loadData.flagPerformance(video.id, core.getVal(core.init('#' + constants.CSS_TOUCHCAST_FLAG_REASON + '')), function(data) {
                        var msg = 'The TouchCast has been flagged';
                        if (data === 1) {
                            core.hide(flagBtn);
                        }
                        else {
                            core.show(flagBtn);
                            core.removeClass(flagBtn, constants.CSS_TOUCHCAST_UNFLAG_BUTTON);
                            msg = 'The TouchCast has been unflagged';
                        }
                        core.init('.' + constants.CSS_TOUCHCAST_FLAG_MESSAGE + '').html(msg);
                    });
                    return false;
                });
            }
    	}
    }
});
